module.exports = __webpack_public_path__ + "img/img.802e2576.png";